import { graphql } from "@/graphql/codegen/gql.ts"

// Fragment
graphql(`
  fragment CompanyAccountingTermListFields on CompanyAccountingTerm {
    companyAccountingTermId
    companyType
    companyId
    creditLimit
    paymentTermId
    paymentTerm {
      paymentTermId
      name
    }
  }
`)

graphql(`
  query CompanyAccountingTermList($input: CompanyAccountingTermListInput!) {
    companyAccountingTerm {
      list(input: $input) {
        __typename
        ... on CompanyAccountingTermListSuccess {
          companyAccountingTerm {
            ...CompanyAccountingTermListFields
          }
        }
        ... on CompanyAccountingTermFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
